/**
 * Type of exact match found between buyer and candidate
 * Ordered by match strength (strongest first)
 */
export enum ExactMatchType {
    RegistrationNumber = 'registration-number',
    NameAndAddress = 'name-and-address',
    Name = 'name',
    Address = 'address',
    None = 'none',
}
